import * as Icons from "lucide-react";
import { SUITES } from "../../data/content";

export const AutonomousSuites = () => (
  <section id="suites" className="py-20 md:py-32 bg-white" data-testid="suites-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37] font-semibold">Autonomous Practice Suites</p>
        <h2 className="mt-4 font-serif text-3xl md:text-4xl text-[#0B1B2B] tracking-tight">
          Independence, Engineered.
        </h2>
        <p className="mt-6 text-base md:text-lg text-[#64748B] leading-relaxed">
          Purpose-built advisory and operational suites for nurse practitioners advancing to autonomous practice under
          <span className="font-semibold text-[#0B1B2B]"> N.J.A.C. 13:35-6.17</span> — from formation through fully independent operations.
        </p>
      </div>
      <div className="lg:col-span-8 mt-12 lg:mt-0 grid grid-cols-1 md:grid-cols-3 gap-6">
        {SUITES.map((s) => {
          const C = Icons[s.icon] || Icons.Circle;
          return (
            <div key={s.title} className="border border-[#E2E8F0] bg-[#F8FAFC] rounded-xl p-8 transition-all duration-300 hover:shadow-xl hover:border-[#D4AF37]/50">
              <C size={26} className="text-[#D4AF37]" />
              <h3 className="mt-5 font-serif text-xl text-[#0B1B2B] font-semibold leading-snug">{s.title}</h3>
              <p className="mt-3 text-sm text-[#64748B] leading-relaxed">{s.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
